import { Button, Heading, List } from '@boltenergy-be/design-system'
import { useTranslation } from 'next-i18next/pages'
import Link from 'components/link/Link'
import { routes } from 'utils/routes'
import { startSimulationOrRegistration } from 'utils/customerFlow'
import classNames from 'classnames'
import styles from 'features/producer-contact/components/b2b-offering-card/B2bOfferingCard.module.scss'
import parse from 'html-react-parser'
import { B2BOfferingCardProps } from './types'
import { trackGTMEvent } from 'utils/tracking'
import { CommonGTMEvents, CommonTrackingParams } from 'types/tracking'
import { useStoreDispatch } from 'hooks/store'
import { useGetLanguage } from 'hooks/useGetLanguage'
import { InputGroupKeys, PersonalDataFieldKeys } from 'store/customer/enums'
import { updateInput } from 'store/customer/slice'

const B2bOfferingCard = ({ product, className }: B2BOfferingCardProps) => {
  // Redux
  const dispatch = useStoreDispatch()

  // i18n
  const { t } = useTranslation('b2b', { keyPrefix: `overview.offering.products.${product}` })
  const language = useGetLanguage()

  return (
    <article className={classNames(styles.card, className)}>
      <header>
        <Heading as="h2" variant="h4" serif>
          {t('title')}
        </Heading>

        <small className={styles.description}>{t('description')}</small>

        <Heading as="h3" variant="h4" className="mb-500 mt-auto">
          {t('pricing')}
        </Heading>
      </header>

      <List as="ul" className={styles.list}>
        {(t('bullets', { returnObjects: true }) as string[]).map((item, index) => (
          <li key={`${product}-feature-${index}`}>{parse(item)}</li>
        ))}
      </List>

      {product === 'basic' ? (
        <Button
          type="button"
          onClick={() => {
            dispatch(
              updateInput({
                group: InputGroupKeys.PERSONAL_DATA,
                key: PersonalDataFieldKeys.IS_COMPANY,
                value: true
              })
            )
            startSimulationOrRegistration()
          }}
          isFullwidth
        >
          {t('action')}
        </Button>
      ) : (
        <Link
          representation="button"
          href={routes(language).becomeProducerForm}
          onNavigate={() => trackGTMEvent(CommonGTMEvents.PRODUCER_CONTACT_CLICKED, { [CommonTrackingParams.B2B_PRODUCT]: product })}
          isFullwidth
        >
          {t('action')}
        </Link>
      )}
    </article>
  )
}

export default B2bOfferingCard
